export class TusClientErrorResponsePrettifier {
  static genericErrorMessage() {
    return 'There appears to be a network error.';
  }

  static prettify(tusMessage) {
    const responseTextRegexp = /response text:\s(.*)/;
    const match = responseTextRegexp.exec(tusMessage);
    if (match) {
      return match[1];
    }
    return TusClientErrorResponsePrettifier.genericErrorMessage();
  }
}
